import React, { useState } from 'react';
import Button from '../../../../../ui-core/Button/Button';
import PropTypes from 'prop-types';
import './style.css';
import { getUserAttribute } from '../../../../../utils/helpers';
import Modal from '../../../../NewHome/components/Modal';
import InputField from '../../../../../ui-core/InputField';
import { createSubscriptionRequest } from '../../../../../api/subscribe';
import { toast } from 'react-toastify';

function Footer({ onClick }) {
  const subscriptionDetails = getUserAttribute('subscription_details');
  const freeTrial = getUserAttribute('free_trial');

  const noSubscription = !subscriptionDetails?.subscribed;
  const noFreeTrails = !freeTrial;
  const noActiveSubscription = noSubscription ? noFreeTrails : false;
  const [showModal, setShowModal] = useState(false);
  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const isValidEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  return (
    <>
      {noActiveSubscription && (
        <div
          onClick={() => {
            setShowModal(true);
          }}
          className="cursor-pointer footer-image d-flex align-items-end"
        >
          {/* <h3>Discover the one stretch you’re missing in yoga!</h3> */}
          <div>
            {/* <p>Ready to learn more from DocJen?</p> */}
            <Button
              text="Get my Guide!"
              class="btn-style"
              onClick={() => {
                // onClick(
                //   TEXT_CONSTANT.START_FREE_TRAIL,
                //   'isSignup',
                //   TEXT_CONSTANT.START_FREE_TRAIL,
                // );
                setShowModal(true);
              }}
            />
          </div>
        </div>
      )}
      <Modal
        // dialogClassName={dialogClassName}
        show={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
      >
        <div className="col-12 col-lg-6 col-xl-5 w-100 right-footer">
          {alreadySubscribed ? (
            <div className="w-100">Subscribed successfully</div>
          ) : (
            <div className="newsletter-email">
              <InputField
                type="text"
                name="email"
                placeholder="Enter Your Email Address"
                value={emailValue}
                className="w-100"
                handleChange={ev => setEmailValue(ev.target.value)}
              />
              <Button
                text="SUBMIT"
                isLoading={subscribeLoading}
                isDisabled={!isValidEmail(emailValue)}
                onClick={async () => {
                  try {
                    if (emailValue && isValidEmail(emailValue)) {
                      setSubscribeLoading(true);
                      const response = await createSubscriptionRequest({
                        email: emailValue,
                      });
                      if (response?.data?.response?.data?.registered_user) {
                        setAlreadySubscribed(true);
                      }
                      setSubscribeLoading(false);
                      setShowModal(false);
                      toast.success('Subscribed successfully!');
                    }
                  } catch (error) {
                    setSubscribeLoading(false);
                    console.error(error);
                  }
                }}
                class="btn-style w-100 mt-4 text-center"
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

export default Footer;

Footer.propTypes = {
  onClick: PropTypes.func,
};
